import React from 'react';

export interface BreadcrumbItem {
  key: string;
  label: string;
  icon?: string; // emoji or icon font placeholder
  onClick?: () => void;
  isCurrent?: boolean;
  after?: React.ReactNode; // optional trailing element (e.g., help icon)
}

interface BreadcrumbProps {
  items: BreadcrumbItem[];
  separator?: string; // default '//'
  className?: string;
}

const Breadcrumb: React.FC<BreadcrumbProps> = ({ items, separator = '//', className }) => {
  return (
    <nav className={`breadcrumb ${className || ''}`} aria-label="Breadcrumb">
      <ol className="breadcrumb-list">
        {items.map((item, idx) => {
          const isLast = idx === items.length - 1;
          const hasLabel = item.label && item.label.trim().length > 0;
          const content = (
            <span className={`bc-label ${item.isCurrent ? 'current' : ''} ${item.isCurrent ? 'current-module' : ''}`}>
              {item.icon && <span className="bc-icon" aria-hidden="true">{item.icon}</span>}
              {hasLabel && <span className="bc-text">{item.label}</span>}
              {item.after && <span className="bc-after" aria-hidden="false">{item.after}</span>}
            </span>
          );
          return (
            <li key={item.key} className={`bc-item ${item.isCurrent ? 'active' : ''}`}>{item.onClick && !isLast ? (
              <button type="button" onClick={item.onClick} className="bc-link" aria-current={item.isCurrent ? 'page' : undefined}>{content}</button>
            ) : (
              <span className="bc-static" aria-current={item.isCurrent ? 'page' : undefined} role={item.isCurrent ? 'heading' : undefined} aria-level={item.isCurrent ? 1 : undefined}>{content}</span>
            )}{!isLast && <span className="bc-separator" aria-hidden="true">{separator}</span>}</li>
          );
        })}
      </ol>
    </nav>
  );
};

export default Breadcrumb;